import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, CircularProgress, Box, TablePagination
} from '@mui/material';
// Import das setas
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

const Home = () => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    axios.get('/api/movements/')
      .then(response => {
        setMovements(response.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erro ao carregar os movimentos:", err);
        setError("Erro ao carregar os movimentos.");
        setLoading(false);
      });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography color="error" align="center">{error}</Typography>;
  }

  // Paginação: recorta os movimentos para a página atual
  const paginatedMovements = movements.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper sx={{ mt: 2 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Produto</TableCell>
              <TableCell>Movimento</TableCell>
              <TableCell>Quantidade</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedMovements.map((movement) => (
              <TableRow key={movement.product_name + movement.movement_date}>
                <TableCell>{movement.product_name}</TableCell>
                <TableCell>
                  {movement.movement_type === 'in' ? (
                    <ArrowUpward sx={{ color: 'green' }} />
                  ) : (
                    <ArrowDownward sx={{ color: 'red' }} />
                  )}
                </TableCell>
                <TableCell>{movement.quantity}</TableCell>
                <TableCell>
                  {new Date(movement.movement_date).toLocaleString()}
                </TableCell>
                <TableCell>{movement.user}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={movements.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Paper>
  );
};

export default Home;
